<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <Card :title="'Edit Pengeluaran Apotek'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'pharmacy-expenses/' + form.id"
            />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import Form from '@/component/pharmacy/pharmacy-expenses/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        date: '',
        name: '',
        ammount: '',
        pharmacy_expense_category_id: '',
        notes: '',
        photo: [],
        photo_name: ''
      },
    }
  },

  methods: {

    async get() {
      this.form = await module.get('pharmacy-expenses/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/pharmacy/pharmacy-expenses/list')
      } else {
        this.form['_method'] = "put"
        this.form.photo_name = this.form.photo
        this.form.pharmacy_expense_category_id = 0
        this.form.photo = []
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Apotek", route:"/pharmacy/dashboard" },
      { title: "Pengeluaran", route: '/pharmacy/pharmacy-expenses/list' },
      { title: 'Edit Pengeluaran' }
    ])
    // Get Data
    this.get()
  },

}
</script>

<style>
</style>